import omit from 'lodash-es/omit';
import flattenDeep from 'lodash-es/flattenDeep';
import { AutomationRunActionPromptType } from 'shared/types/graphql';
import { Errors, ErrorType } from '../../types/AutomationValidation';

interface PromptError {
  promptType: AutomationRunActionPromptType;
  promptIndex: number;
  errors?: ErrorType[];
}

export interface FlattenedErrors {
  generalErrors: ErrorType[];
  promptErrors?: PromptError[];
}

export const getFlattenedAutomationErrors = (errors: Errors): FlattenedErrors => {
  const fieldErrors = Object.values(omit(errors, ['sendConditions', 'prompts', 'validationActionWord']));
  const sendConditionErrors = Object.values(errors.sendConditions);
  const promptErrors: PromptError[] = [];

  if (errors.prompts.length) {
    errors.prompts.forEach((promptError) => {
      const generalPromptErrors: ErrorType[][] = Object.values(
        omit(promptError, ['buttons', 'promptIndex', 'promptType']),
      ).filter((error) => error.length > 0);

      let buttonErrors: ErrorType[] = [];
      if (promptError.buttons.length) {
        buttonErrors = flattenDeep(promptError.buttons.map((error) => Object.values(omit(error, 'buttonIndex'))));
      }

      const flattenedPromptErrors = flattenDeep([...generalPromptErrors, ...buttonErrors]);

      if (flattenedPromptErrors.length) {
        promptErrors.push({
          promptType: promptError.promptType,
          promptIndex: promptError.promptIndex,
          errors: flattenedPromptErrors,
        });
      }
    });
  }

  return {
    generalErrors: flattenDeep([...fieldErrors, ...sendConditionErrors]),
    promptErrors: promptErrors,
  };
};
